import { Routes } from '@angular/router';
import { DeclarationsComponent } from './modules/campaigns/declarations/declarations.component';
import { DeclarationDetailComponent } from './modules/campaigns/declaration-detail/declaration-detail.component';
import { LoginComponent } from './modules/login/login.component';
import { MultipleGestionComponent } from './modules/campaigns/multiple-gestion/multiple-gestion.component';
import { DeclarationLogComponent } from './modules/campaigns/declaration-log/declaration-log.component';
import { canViewUser, hasPermission, isLogged } from './core/guards/auth.guard';
import { HomeComponent } from './modules/home/home.component';
import { ClientsListComponent } from './modules/clients/clients-list/clients-list.component';
import { ClientDetailComponent } from './modules/clients/client-detail/client-detail.component';
import { ModelDetailComponent } from './modules/models/model-detail/model-detail.component';
import { ClientsMasterComponent } from './modules/clients/clients-master/clients-master.component';
import { XmlTransformComponent } from './modules/xml-transform/xml-transform.component';
import { UsersListComponent } from './modules/users/users-list/users-list.component';
import { UserDetailComponent } from './modules/users/user-detail/user-detail.component';
import { Permission } from './core/enums/permission.enum';
import { OperationWizardPageComponent } from './components/forms/operaciones-societarias-form/operation-wizard/operation-wizard-page.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'home',
        canActivate: [isLogged],
        component: HomeComponent,
    },
    {
        path: 'declarations',
        canActivate: [hasPermission],
        data: { title: 'Declaraciones', permission: Permission.ManageCampaigns },
        component: DeclarationsComponent,
    },
    {
        path: 'declarations/detail/:id',
        canActivate: [hasPermission],
        data: { permission: Permission.ManageCampaigns },
        component: DeclarationDetailComponent,
    },
    {
        path: 'declarations/multiple-gestion',
        canActivate: [hasPermission],
        data: { permission: Permission.ManageCampaigns },
        component: MultipleGestionComponent,
    },
    {
        path: 'declarations/log/:id',
        canActivate: [hasPermission],
        data: { permission: Permission.ManageCampaigns },
        component: DeclarationLogComponent,
    },
    {
        path: 'new-model',
        canActivate: [isLogged],
        component: ModelDetailComponent,
    },
    {
        path: 'clients',
        canActivate: [hasPermission],
        data: { title: 'Clientes', permission: Permission.ManageClients },
        component: ClientsListComponent,
    },
    {
        path: 'clients/detail/:id/nueva-operacion',
        canActivate: [hasPermission],
        data: { permission: Permission.ManageClients },
        component: OperationWizardPageComponent,
    },
    {
        path: 'clients/detail/:id',
        canActivate: [hasPermission],
        data: { permission: Permission.ManageClients },
        component: ClientDetailComponent,
    },
    {
        path: 'clients-master',
        canActivate: [isLogged],
        data: { title: 'Maestro de clientes' },
        component: ClientsMasterComponent,
    },
    {
        path: 'users',
        canActivate: [hasPermission],
        data: { title: 'Usuarios', permission: Permission.ManageUsers },
        component: UsersListComponent,
    },
    {
        path: 'users/detail/:id',
        canActivate: [canViewUser],
        component: UserDetailComponent,
    },
    {
        path: 'xml-transform',
        canActivate: [isLogged],
        data: { title: 'Transformar XML' },
        component: XmlTransformComponent,
    },
    {
        path: 'client-requests',
        canActivate: [hasPermission],
        data: { title: 'Solicitudes de clientes', permission: Permission.ManageRequests },
        loadComponent: () => import('./modules/client-requests/client-requests.component').then(m => m.ClientRequestsComponent),
    },
    {
        path: 'client-requests/detail/:id',
        canActivate: [hasPermission],
        data: { permission: Permission.ManageRequests },
        loadComponent: () => import('./modules/client-requests/client-requests-detail/client-requests-detail.component').then(m => m.ClientRequestsDetailComponent),
    },
    {
        path: '**',
        redirectTo: 'home',
        pathMatch: 'full',
    },
];